import {ReactElement, useState} from 'react';

import {ClickAwayListener, Tooltip, useMediaQuery, useTheme} from '@mui/material';

import {greenColors, orangeColors} from '../../layouts/theme/designSystem';

interface Props {
  isEnabled?: boolean;
  title: string;
  children: ReactElement;
  placement?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top';
}

export const EmpionTooltip = ({isEnabled, title, children, placement}: Props) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const [open, setOpen] = useState(false);

  const onClickHandler = () => {
    if (!isDesktop && isEnabled) {
      setOpen(!open);
    }
  };

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const onHover = (value: boolean) => {
    if (isDesktop && isEnabled) {
      setOpen(value);
    }
  };

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <Tooltip
        title={title}
        arrow
        open={open}
        onClose={handleTooltipClose}
        placement={placement}
        componentsProps={{
          tooltip: {
            sx: {
              bgcolor: orangeColors[5],
              color: greenColors[700],
              fontWeight: 'bold',
              fontSize: '15px',
              borderRadius: '16px',
              border: `1px solid ${orangeColors[3]}`,
              '& .MuiTooltip-arrow': {
                color: orangeColors[5],
              },
            },
          },
        }}
      >
        <span
          data-testid='tool-tip'
          onClick={onClickHandler}
          onMouseEnter={() => onHover(true)}
          onMouseLeave={() => onHover(false)}
        >
          {children}
        </span>
      </Tooltip>
    </ClickAwayListener>
  );
};
